export default function updateViewingRenterSearchFilters({ state }, { filterKey, filterValue }) {
  state.set(['agentMapView', 'viewingRenterSearchFilters', filterKey], filterValue);
  state.commit();
}
